// extracted by mini-css-extract-plugin
export default {"main":"TechnologyCard_main__3zbXe","imgDiv":"TechnologyCard_imgDiv__ySkOm","gifContainer":"TechnologyCard_gifContainer__2ckpl","info":"TechnologyCard_info__4m3gk"};